const modulesFiles = require.context('./subapp-config', true, /\.js$/);

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

const AppModules = modules;

/**
 * 根据name获取appCode
 * @param name 应用名称
 * @returns {string}
 */
export function getAppCodeByName(name) {
  if (!Reflect.has(AppModules, name)) {
    return '';
  }
  return AppModules[name].appCode;
}

// 导出子系统列表
export default AppModules;
